__turbopack_context__.v({
  "dropzoneWrapper": "index-module__rG_FrW__dropzoneWrapper",
});
